import { combineReducers } from "redux";
import slider from "./slider";
import settings from "./settings";
import navigation from "./navigation";
import announcements from "./announcements";
import about_us from "./about_us";
import config from "./config";
import reviews from "./reviews";
import posts from "./post";
import pages from "./page";
import single_post from "./single_post";
import single_page from "./single_page";
import screen from "./screen";
import categories from "./categories";
import sub_categories_post from "./sub_categories_post";
import branches from "./branches";
import single_announcement from "./single_announcement";
import atms from "./atms";
import organization from "./organization";
import money_gram from "./money_gram";
import sub_category from "./sub_category";
import teams from "./teams";
import criteria from "./criteria";
import loan_calculation from "./loan_calculation";
import category from "./category";
import bultens from "./bultens";
import bulten from "./bulten";
import cards from "./cards";
import card_applications from "./card_applications";
import credits from "./credits";
import credit_type from "./credit_type";
const rootReducer = combineReducers({
  criteria,
  slider,
  settings,
  navigation,
  announcements,
  about_us,
  config,
  money_gram,
  reviews,
  posts,
  pages,
  single_post,
  single_page,
  single_announcement,
  screen,
  categories,
  sub_categories_post,
  branches,
  atms,
  organization,
  teams,
  loan_calculation,
  sub_category,
  category,
  bultens,
  bulten,
  cards,
  card_applications,
  credits,
  credit_type
});
export default rootReducer;
